var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Ruler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.001,
    height: 41,
    viewBox: "0 0 41.001 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-ruler",
    d: "M30.823,4.01a5.622,5.622,0,0,0-3.988,1.642L5.652,26.835a5.663,5.663,0,0,0,0,7.976l8.557,8.557a5.663,5.663,0,0,0,7.976,0L43.369,22.184a5.663,5.663,0,0,0,0-7.976L34.811,5.652A5.622,5.622,0,0,0,30.823,4.01Zm0,3.056a2.556,2.556,0,0,1,1.813.761l8.557,8.557a2.537,2.537,0,0,1,0,3.623L20.009,41.192a2.541,2.541,0,0,1-3.625,0L7.827,32.636a2.541,2.541,0,0,1,0-3.625L9.64,27.2l1.989,1.989A1.538,1.538,0,1,0,13.8,27.011l-1.989-1.989,2.952-2.952,4.04,4.04a1.538,1.538,0,1,0,2.175-2.175l-4.04-4.04L19.9,16.943l1.989,1.989a1.538,1.538,0,1,0,2.175-2.175L22.07,14.768l2.952-2.952,4.04,4.04a1.538,1.538,0,1,0,2.175-2.175L27.2,9.64,29.01,7.827A2.556,2.556,0,0,1,30.823,7.066Z",
    transform: "translate(-4.01 -4.01)",
    fill: "#6e6e72"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Ruler);
export default __webpack_public_path__ + "static/media/icons8-ruler.5663ee38.svg";
export { ForwardRef as ReactComponent };